import { useEffect, useRef } from 'react';
import socket from 'shared/socket';

/* Suscribe a los eventos de sincronizacion emitidos por el backend a la sala
   e{empresaId}_asesores: sync_estado, sync_completada, inventario_actualizado.
   Mismo patron que useTrabajadorSocket (callbacksRef + join en connect). */
const useSyncSocket = ({ onEstado, onCompletada, onInventario }) => {
  const cbRef = useRef({ onEstado, onCompletada, onInventario });
  cbRef.current = { onEstado, onCompletada, onInventario };

  useEffect(() => {
    const onConnect = () => {
      const user = JSON.parse(localStorage.getItem('usuario') || 'null');
      const idempresa = user?.idempresa;
      if (idempresa) socket.emit('join_room', `e${idempresa}_asesores`);
    };

    if (!socket.connected) socket.connect();
    else onConnect();

    const handleEstado = (data) => {
      if (cbRef.current.onEstado) cbRef.current.onEstado(data);
    };
    const handleCompletada = (data) => {
      if (cbRef.current.onCompletada) cbRef.current.onCompletada(data);
    };
    const handleInventario = (data) => {
      if (cbRef.current.onInventario) cbRef.current.onInventario(data);
    };

    socket.on('connect', onConnect);
    socket.on('sync_estado', handleEstado);
    socket.on('sync_completada', handleCompletada);
    socket.on('inventario_actualizado', handleInventario);

    return () => {
      socket.off('connect', onConnect);
      socket.off('sync_estado', handleEstado);
      socket.off('sync_completada', handleCompletada);
      socket.off('inventario_actualizado', handleInventario);
    };
  }, []);
};

export default useSyncSocket;
